export default __webpack_public_path__ + "static/1234-817fa3e534f468ecc890630064787988.gif";